import { render, staticRenderFns } from "./details-matrix.page.vue?vue&type=template&id=70bcfd00&scoped=true&"
import script from "./details-matrix.page.vue?vue&type=script&lang=js&"
export * from "./details-matrix.page.vue?vue&type=script&lang=js&"
import style0 from "./details-matrix.page.vue?vue&type=style&index=0&id=70bcfd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bcfd00",
  null
  
)

export default component.exports